<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-dark btn-sm"
      data-bs-toggle="modal"
      data-bs-target="#searchModal"
      @click="focusOnSearch"
    >
      <i class="fas fa-search"></i>
    </button>

    <div
      ref="modal"
      class="modal fade"
      id="searchModal"
      tabindex="-1"
      aria-labelledby="searchModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <div class="input-group">
              <input
                ref="search_input"
                type="text"
                class="form-control"
                :placeholder="$t('Search')"
                :aria-label="$t('Search')"
                aria-describedby="button-addon2"
                @input="debouncedSearch"
              />
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div>
              <transition-group name="component-fade">
                <div key="00" class="small" v-if="message">
                  {{ message }}
                </div>
                <div key="1" v-if="loading" class="text-center mt-5">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div v-else key="2">
                  <div v-if="results.courses?.length" class="">
                    <div v-for="course in results.courses" :key="course.id" class="">
                      <div class="card mb-2 hover-bg-gray">
                        <div class="row g-0">
                          <div class="col-3">
                            <img
                              :src="imgUrl(course.cover_photo)"
                              class="img-fluid rounded-start"
                              :alt="course.title"
                            />
                          </div>
                          <div class="col-9 d-flex align-items-center">
                            <div class="card-body">
                              <a :href="`/${course.slug}`" class="small fw-semibold text-dark stretched-link">
                                {{ course.title }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      debouncedSearch: null,
      modal: null,
      results: {},
      loading: false,
      message: null,
    }
  },
  methods: {
    imgUrl(url) {
      if (url) {
        return `https://djceg34j53tq.cloudfront.net/${url}`
      }
      return 'https://placehold.co/1280x800/E1D4F1/ffffff'
    },

    search(event) {
      const q = event.target.value
      this.message = null
      if (q) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'search',
            search_query: q
          })
        }
        this.loading = true
        axios
          .post('/search', { q })
          .then((response) => {
            setTimeout(() => {
              this.loading = false
            }, 100)
            return response
          })
          .then(({ data }) => {
            this.results = data
          })
          .then(() => {
            if (!this.results.courses?.length) {
              this.message = `${this.$t('No results this time')}. ${this.$t('Please try again')}.`
            }
          })
          .catch((error) => {
            this.results = {}
            let status = _.get(error, 'response.status')
            if (status === 422) {
              this.message = _.get(error, 'response.data.errors.q[0]')
            }

            this.loading = false
          })
      } else {
        this.results = {}
      }
    },
    focusOnSearch() {
      this.$refs.search_input.focus()
    },
  },
  created() {
    this.debouncedSearch = _.debounce(this.search, 500)
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {})
    this.$refs.modal.addEventListener('shown.bs.modal', () => {
      this.focusOnSearch()
    })
  },
}
</script>

<style>
.hover-bg-gray {
  transition: background-color 0.15s ease-in-out;
}
.hover-bg-gray:hover {
  background-color: #f8f9fa;
}
</style>
